import { memo } from "react";
import { useHistory } from "react-router-dom";
import { TableCell, TableRow } from "@material-ui/core";
import { GetLmsConnectionsReportQuery } from "../../../generated/graphql";
import { SchoolPaths } from "../../shared/constants";
import { REPORT_COLUMNS, REPORT_EMPTY, ReportColumnId } from "./constants";
import { SchoolNameCell } from "./styles";
import { formatReportDate } from "./utils";

type ReportRow =
  GetLmsConnectionsReportQuery["getLmsConnectionsReport"]["rows"][number];

interface ReportRowsProps {
  rows: ReportRow[];
}

/** A single full-width line in the table body: empty state, error, ... */
export const ReportMessageRow = ({ text }: { text: string }) => (
  <TableRow>
    <TableCell colSpan={REPORT_COLUMNS.length} align="center">
      {text}
    </TableCell>
  </TableRow>
);

// Personal (B2C) and institutional (B2B) schools live on different admin pages — same split as
// SchoolsTable.getSchoolRoute.
const schoolRoute = ({ schoolId, isPersonalSchool }: ReportRow) =>
  isPersonalSchool
    ? `/${SchoolPaths.personal}/${schoolId}/edit`
    : `/${SchoolPaths.school}/${schoolId}/edit`;

export const ReportRows = memo(({ rows }: ReportRowsProps) => {
  const history = useHistory();

  if (rows.length === 0) {
    return <ReportMessageRow text={REPORT_EMPTY} />;
  }

  return (
    <>
      {rows.map((row) => (
        <TableRow key={row.lmsSchoolMappingId} hover>
          {REPORT_COLUMNS.map(({ id }) => {
            switch (id) {
              case ReportColumnId.SchoolName:
                return (
                  <SchoolNameCell
                    key={id}
                    align="center"
                    onClick={() => history.push(schoolRoute(row))}
                  >
                    {row.schoolName}
                  </SchoolNameCell>
                );
              case ReportColumnId.FirstLaunchAt:
              case ReportColumnId.LastLaunchAt:
                return (
                  <TableCell key={id} align="center">
                    {formatReportDate(row[id])}
                  </TableCell>
                );
              default:
                return (
                  <TableCell key={id} align="center">
                    {row[id]}
                  </TableCell>
                );
            }
          })}
        </TableRow>
      ))}
    </>
  );
});
